module.exports = __webpack_public_path__ + "img/folder-open-solid.831da29f.svg";